<template>
  <v-text-field
    v-bind="$props"
    v-on="$listeners"
    :error-messages="msg"
    @keydown="test"
    @blur="clear"
    outlined
    dense
    class="ag-mask-text"
    :rules="localRules"
  />
</template>

<script>
import { mask } from "vue-the-mask";
import { VTextField } from "vuetify/lib";

export default {
  name: "MaskedTextField",
  props: {
    ...VTextField.options.props,
    pattern: RegExp,
    rules: Array,
  },
  directives: { mask },
  data() {
    return {
      localRules: [
        ...this.rules,
        (v) => !!v && v.split('').every(char => this.pattern.test(char)) || this.label + " может содержать только буквы кириллицы",
        (v) => !!v && v.length <= 20 || this.label + " не может содержать больше 20 букв",
      ],
      msg: "",
    };
  },

  methods: {

    test(e) {
      // if (this.value.length >= 20) {
      //   if (e && e.key && e.key.length === 1) {
      //     this.msg = this.label + " не может содержать больше 20 букв";
      //     e.preventDefault();
      //   } else {
      //     this.clear();
      //   }
      // } else {
      //   if (e && e.key && e.key.length === 1 && !this.pattern.test(e.key)) {
      //     this.msg = this.label + " может содержать только буквы кириллицы";
      //     e.preventDefault();
      //   } else {
      //     this.clear();
      //   }
      // }
    },
    clear() {
      // this.msg = "";
    },
  },
};
</script>

<style lang="scss">
.ag-mask-text.v-text-field .v-text-field__details {
  position: absolute;
  top: 44px;
}

.ag-mask-text > .v-input__control > .v-input__slot {
  margin-bottom: 0;
}
</style>
